import Vue from 'vue'
import VueRouter from 'vue-router'
import MainHomepage from '@/components/MainHomepage.vue'

Vue.use(VueRouter)

const router = new VueRouter({
    //
    routes: [
        {
            path: '/',
            name: 'MainHomepage',
            component: MainHomepage,
            meta: {
                title: '首页-北京云智轩科技有限公司'
            }
        },
        {
            path: '/MainHardware',
            name: 'MainHardware',
            component: () => import('../components/MainHardware.vue'),
            meta: {
                title: '硬件产品-北京云智轩科技有限公司'
            }
        },
        {
            path: '/MainSoftware',
            name: 'MainSoftware',
            component: () => import('@/components/Mainsoftware.vue'),
            meta: {
                title: '软件产品-北京云智轩科技有限公司'
            }
        },
        {
            path: '/MainTypicalcase',
            name: 'MainTypicalcase',
            component: () => import('@/components/MainTypicalcase.vue'),
            meta: {
                title: '典型案例-北京云智轩科技有限公司'
            }

        },
        {
            path: '/Mainabout',
            name: 'Mainabout',
            component: () => import('@/components/Mainabout.vue'),
            meta: {
                title: '关于我们-北京云智轩科技有限公司'
            }

        },
        //硬件详情
        {
            path: '/juanlianji-qi',
            name: 'juanlianji-qi',
            component: () => import('@/components/HardwareDetails/juanlianji-qi.vue'),
            meta: { hideNavigation: false }

        },
        {
            path: '/juanlianji-zy',
            name: 'juanlianji-zy',
            component: () => import('@/components/HardwareDetails/juanlianji-zy.vue'),
            meta: { hideNavigation: false }

        },
        {
            path: '/FangfengjiDetails',
            name: 'FangfengjiDetails',
            component: () => import('@/components/HardwareDetails/FangfengjiDetails.vue'),
            meta: { hideNavigation: false }

        },
        {
            path: '/ShuifeijiDetails',
            name: 'ShuifeijiDetails',
            component: () => import('@/components/HardwareDetails/ShuifeijiDetails.vue'),
            meta: { hideNavigation: false }

        },
        {
            path: '/HuanjingjianceDetails',
            name: 'HuanjingjianceDetails',
            component: () => import('@/components/HardwareDetails/HuanjingjianceDetails.vue'),
            meta: { hideNavigation: false }

        },
        {
            path: '/CanshuDetails',
            name: 'CanshuDetails',
            component: () => import('@/components/HardwareDetails/CanshuDetails.vue'),
            meta: { hideNavigation: false }

        },
        //软件详情
        {
            path: '/wangwenguaDetails',
            name: 'wangwenguaDetails',
            component: () => import('@/components/SoftwareDetails/wangwenguaDetails.vue'),
            meta: { hideNavigation: false }

        },
        {
            path: '/dashujuDetails',
            name: 'dashujuDetails',
            component: () => import('@/components/SoftwareDetails/dashujuDetails.vue'),
            meta: { hideNavigation: false }

        },
        {
            path: '/shuzinongyeDetails',
            name: 'shuzinongyeDetails',
            component: () => import('@/components/SoftwareDetails/shuzinongyeDetails.vue'),
            meta: { hideNavigation: false }

        },
        {
            path: '/zhinengguangaiDetails',
            name: 'zhinengguangaiDetails',
            component: () => import('@/components/SoftwareDetails/zhinengguangaiDetails.vue'),
            meta: { hideNavigation: false }

        },
        {
            path: '/xinpengdaojiaDetails',
            name: 'xinpengdaojiaDetails',
            component: () => import('@/components/SoftwareDetails/xinpengdaojiaDetails.vue'),
            meta: { hideNavigation: false }

        },
        {
            path: '/xinpengzhiyunDetails',
            name: 'xinpengzhiyunDetails',
            component: () => import('@/components/SoftwareDetails/xinpengzhiyunDetails.vue'),
            meta: { hideNavigation: false }

        },
        //案例详情
        {
            path: '/funingcunDetails',
            name: 'funingcunDetails',
            component: () => import('@/components/TypicalcaseDetails/funingcunDetails.vue'),
            meta: { hideNavigation: false }

        },
        {
            path: '/gczrgwsDetails',
            name: 'gczrgwsDetails',
            component: () => import('@/components/TypicalcaseDetails/gczrgwsDetails.vue'),
            meta: { hideNavigation: false }

        },
        {
            path: '/pysznyDetails',
            name: 'pysznyDetails',
            component: () => import('@/components/TypicalcaseDetails/pysznyDetails.vue'),
            meta: { hideNavigation: false }

        },
        {
            path: '/xijixianDetails',
            name: 'xijixianDetails',
            component: () => import('@/components/TypicalcaseDetails/xijixianDetails.vue'),
            meta: { hideNavigation: false }

        },
        {
            path: '/yunnanhhDetails',
            name: 'yunnanhhDetails',
            component: () => import('@/components/TypicalcaseDetails/yunnanhhDetails.vue'),
            meta: { hideNavigation: false }

        },
        {
            path: '/zhnyDetails',
            name: 'zhnyDetails',
            component: () => import('@/components/TypicalcaseDetails/zhnyDetails.vue'),
            meta: { hideNavigation: false }

        },




    ],
    scrollBehavior(to) {
        if (to.hash) {
            return {
                selector: to.hash,
                behavior: 'smooth'
            }
        }
        return { x: 0, y: 0 }
    }
})
router.beforeEach((to, from, next) => {
    document.title = to.meta.title || '北京云智轩科技有限公司'
    next()
})

export default router
